import {useContext, useEffect} from "preact/hooks";
import {AsRoute, GlobalDataContext} from "../../app";
import Router, {route} from "preact-router";
import {subUrl} from "../../lib/url";
import {Page} from "../page";
import {Card} from "../generic/card";
import {Link} from "preact-router/match";
import {SensorsAdmin} from "./admin/sensors";
import {SensorSetsAdmin} from "./admin/sensorSets";
import {ApiKeysAdmin} from "./admin/apiKeys";
import {ConfigurationAdmin} from "./admin/configuration";
import {LogViewCard} from "./admin/log";
import {WithAPI} from "../../api/temperature";
import {Column, UnevenColumns} from "../generic/columns";
import {Menu} from "../generic/menu";

export function Redirect(props: AsRoute & {to: string}) {
    useEffect(() => {
        route(props.to, true);
    });

    return null;
}

export function Admin(props: AsRoute & WithAPI) {
    const global = useContext(GlobalDataContext);
    if (global && !global?.user) {
        const url = new URL("/login", location.href);
        url.searchParams.set("return", `${location.pathname}${location.search}`);
        window.location.href = url.toString();
    }

    const adminUrl = (sub: string): string => {
        return subUrl("/admin", sub);
    }

    return <Page showBackButton={true}>
        <UnevenColumns style={{flexGrow: 1}}>
            <Column style={{flexBasis: "15rem", flexGrow: 0}}>
                <Card title="Administration">
                    <Menu>
                        <li><Link href={adminUrl("sensors")} activeClassName="menu-selected">Sensors</Link></li>
                        <li><Link href={adminUrl("sets")} activeClassName="menu-selected">Sensor sets</Link></li>
                        <li><Link href={adminUrl("keys")} activeClassName="menu-selected">API Keys</Link></li>
                        <li><Link href={adminUrl("configuration")} activeClassName="menu-selected">Configuration</Link></li>
                        <li><Link href={adminUrl("log")} activeClassName="menu-selected">Log</Link></li>
                    </Menu>
                </Card>
            </Column>
            <Column style={{flexGrow: 1, flexBasis: 0}}>
                <Router>
                    <Redirect path={adminUrl("")} to={adminUrl("sensors")} />
                    <SensorsAdmin path={adminUrl("sensors")} api={props.api} />
                    <SensorSetsAdmin path={adminUrl("sets")} api={props.api} />
                    <ApiKeysAdmin path={adminUrl("keys")} api={props.api} />
                    <ConfigurationAdmin path={adminUrl("configuration")} />
                    <LogViewCard path={adminUrl("log")} api={props.api} />
                </Router>
            </Column>
        </UnevenColumns>
    </Page>
}
